var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{staticClass:"snackbar",attrs:{"value":_vm.snackbar,"timeout":_vm.timeout,"color":_vm.color,"top":true,"absolute":true,"auto-height":true}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    ")])}
var staticRenderFns = []

export { render, staticRenderFns }